var exports = {
  "p$": "ResizablePaneHandles.module__handle___Y2h1V2",
  "J3": "ResizablePaneHandles.module__edgeTop___Y2h1V2",
  "xf": "ResizablePaneHandles.module__edgeBottom___Y2h1V2",
  "Ve": "ResizablePaneHandles.module__edgeLeft___Y2h1V2",
  "IW": "ResizablePaneHandles.module__edgeRight___Y2h1V2",
  "wy": "ResizablePaneHandles.module__cornerTopLeft___Y2h1V2",
  "Ty": "ResizablePaneHandles.module__cornerTopRight___Y2h1V2",
  "AU": "ResizablePaneHandles.module__cornerBottomLeft___Y2h1V2",
  "pr": "ResizablePaneHandles.module__cornerBottomRight___Y2h1V2",
};

module.exports = exports;
